module.exports = {
  realm: 'FS',
  market: 'fr-CH',
  domain: 'fr.weightwatchers.ch',
  countryId: '30000',
  vsPath: 'ch/fr',
  spiceLocale: 'fr-ch',
  vsUrl: 'https://www{env}weightwatchers.com/ch/fr',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/fr-ch/messages/',
  cmxSiteUrl: 'https://cmx{env}fr.weightwatchers.ch/',
  currency: 'Fr.',
  decimalSeparator: '.',
  thousandSeparator: '',
  currencyFormat: 'Fr. %number ',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}fr.weightwatchers.ch/login-apis/',
  loginWebUrl: 'https://auth{env}fr.weightwatchers.ch/v2/login/',
  countryCode: 'CH',
  commUlr: 'https://commerce{env}weightwatchers.com/ch/fr/api/',
  timezone1: 'Europe/Zurich',
  timezone2: '+01:00',
};
